<template>
    <div class="pb-5 mt-1">
        <div class="text-14 font-normal text-black mb-2.5">
            ความยินยอม<span class="text-a-gray-a8a8a8">(Optional)</span>
        </div>
        <div class="flex items-center gap-2.5">
            <div @click="toggle()">
                <img src="@/assets/icon/ic-checkbox-inactive.svg" v-show="!modelValue" v-cloak alt=""/>
                <img src="@/assets/icon/ic-checkbox-active.svg" v-show="modelValue" v-cloak alt=""/>
            </div>
            <div class="text-black text-14">
                คุณยอมรับ <span class="text-a-orange-fe5000 underline" @click="showPopup()">ข้อตกลงและเงื่อนไข</span>
            </div>
        </div>
    </div>
</template>
<script>
import { inject } from 'vue';

export default {
    props: {
        modelValue: {
            type: Boolean
        }
    },
    emits: ["update:modelValue"],
    setup: function (props, ctx) {
        /**@type {import("@/types/Modal.d").ModalStore} */
        const modalStore = inject("ModalStore")

        const modalcontroller = modalStore.methods.getModalController()

        const toggle = function () {
            ctx.emit("update:modelValue", !props.modelValue)
        }

        const showPopup = function () {
            modalcontroller.pdpaModal
                .clearModal()
                .setType("files")
                .setTitle("ข้อตกลงและเงื่อนไข")
                .setBtnOk("ยอมรับ")
                .onClickAccept(() => {
                    ctx.emit("update:modelValue", true)
                })
                .show({
                    file: "consent.txt"
                })
        }

        return {
            modalcontroller,
            showPopup,
            toggle
        }
    }
}
</script>
